import React, { Component } from "react";
import { Container, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

export class Footer extends Component<{ visible: Boolean }, {}> {
  render() {
    return (
      this.props.visible && (
        <footer>
          <div className="w-100 mt-5">
            <Container>
              <Row className="my-lg-5 text-muted text-small">
                <Col lg>
                  <p className="mb-4 mb-lg-0">
                    Aiia A/S is a licensed Payment Initiation Service Provider
                    (PISP) and Account Information Service Provider (AISP) and
                    operates under the supervision of the Danish Financial
                    Supervisory Authority.
                  </p>
                </Col>
                <Col lg>
                  <div className="float-lg-right text-lg-right mt-2 mb-4 mb-lg-0">
                    <a href={"mailto:providers@nordicapigateway.com"}>
                      Contact us
                    </a>
                    <br />
                    <Link to="/privacy-policy">Privacy policy</Link>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </footer>
      )
    );
  }
}
